// ENTITIES
import { IFormCadastroRg } from 'pages/iirgd/RgFicDigital/CadastroRg/form';
import { IConfirmacaoAtendimento } from 'pages/iirgd/RgFicDigital/CadastroRg/Modal/ConfirmacaoAtendimento/form';
import {
	IFormInclusaoObsPrimeiraViaMenor,
	IFormInclusaoObsPrimeiraViaMaior,
} from 'pages/iirgd/RgFicDigital/InclusaoObservacoes/Formularios/form';
import { IConsultarDare } from 'store/modules/api/dare/consultarDare/types';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Login } from 'store/modules/api/sgu/loginUnico/types';
import { MultifiliacaoRg, Types } from './types';
import { IConsultaPesquisaObservacao } from '../consultaPesquisaObservacao/types';
import { IConsultaPesquisaCidadaoSelecionado } from '../consultaPesquisaCidadao/types';

export function cadastroRgConfigNovo(): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_RG_CFG_NOVO,
		payload: null,
	};
}

export function cadastroRgConfigAcervo(): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_RG_CFG_ACERVO,
		payload: null,
	};
}

export function cadastroRgConfigEdicao(): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_RG_CFG_EDICAO,
		payload: null,
	};
}

export function cadastroRgConfigRedicao(): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_RG_CFG_REEDICAO,
		payload: null,
	};
}

export function cadastroRgPrimeiraVia(): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_RG_PRIMEIRA_VIA,
		payload: null,
	};
}

export function cadastroRgSegundaVia(): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_RG_SEGUNDA_VIA,
		payload: null,
	};
}

export function cadastroRgDataNascimento(
	dataNascimento: string,
): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_RG_DATA_NASCIMENTO,
		payload: dataNascimento,
	};
}

export function cadastroRgConfirmacaoAtendimento(
	payload: IConfirmacaoAtendimento,
): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_RG_CONFIRMACAO_ATENDIMENTO,
		payload,
	};
}

export function cadastroRgOriginal(
	payload: IFormCadastroRg,
): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_RG_ORIGINAL,
		payload,
	};
}

export function cadastrarRgRequest(
	token: string,
	formValues: IFormCadastroRg,
	login: Login,
): ReducerActionRotaSP {
	return {
		type: Types.CADASTRAR_RG_REQUEST,
		token,
		payload: {
			formValues,
			login,
		},
	};
}

export function cadastrarRgSuccess(data: boolean): ReducerActionRotaSP {
	return {
		type: Types.CADASTRAR_RG_SUCCESS,
		payload: data,
	};
}

export function cadastrarRgFailure(numRg: number | null): ReducerActionRotaSP {
	return {
		type: Types.CADASTRAR_RG_FAILURE,
		payload: numRg,
	};
}

export function atualizarRgRequest(
	token: string,
	original: IFormCadastroRg | null,
	formValues: IFormCadastroRg,
	login: Login,
	isPrimeiraVia: boolean,
	consultaPesquisaCidadaoSelecionado: IConsultaPesquisaCidadaoSelecionado | null,
): ReducerActionRotaSP {
	return {
		type: Types.ATUALIZAR_RG_REQUEST,
		token,
		payload: {
			original,
			formValues,
			login,
			isPrimeiraVia,
			consultaPesquisaCidadaoSelecionado,
		},
	};
}

export function atualizarRgSuccess(data: boolean): ReducerActionRotaSP {
	return {
		type: Types.ATUALIZAR_RG_SUCCESS,
		payload: data,
	};
}

export function atualizarRgFailure(): ReducerActionRotaSP {
	return {
		type: Types.ATUALIZAR_RG_FAILURE,
		payload: null,
	};
}

export function atualizarLote(data: string): ReducerActionRotaSP {
	return {
		type: Types.ATUALIZAR_LOTE_SUCCESS,
		payload: data,
	};
}

export function cadastroRgPrincipal(
	original: IFormCadastroRg | null,
	principal: IFormCadastroRg,
	consultaPesquisaCidadaoSelecionado: IConsultaPesquisaCidadaoSelecionado | null,
): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_RG_PRINCIPAL,
		payload: {
			original,
			principal,
			consultaPesquisaCidadaoSelecionado,
		},
	};
}

export function cadastroRgObsPrimeiraViaMenor(
	data: IFormInclusaoObsPrimeiraViaMenor,
): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_RG_OBS_PRIMEIRA_VIA_MENOR,
		payload: data,
	};
}

export function cadastroRgObsPrimeiraViaMaior(
	data: IFormInclusaoObsPrimeiraViaMaior,
): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_RG_OBS_PRIMEIRA_VIA_MAIOR,
		payload: data,
	};
}

export function cadastroRgObsSegundaVia(
	data: IConsultaPesquisaObservacao,
): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_RG_OBS_SEGUNDA_VIA,
		payload: data,
	};
}

export function cadastroRgVincularDare(
	payload: IConsultarDare,
): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_RG_VINCULAR_DARE,
		payload,
	};
}

export function cadastroRgConfrontoDigital(data: boolean): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_RG_CONFRONTO_DIGITAL,
		payload: data,
	};
}

export function cadastroRgFinalizado(data: boolean): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_RG_FINALIZADO,
		payload: data,
	};
}

export function cadastroRgPortaria606(): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_RG_PORTARIA_606,
		payload: null,
	};
}

export function cadastroRgPortaria606Clear(): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_RG_PORTARIA_606_CLEAR,
		payload: null,
	};
}

export function cadastroRgClear(): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_RG_CLEAR,
		payload: null,
	};
}

export function cadastroRgMultifiliacao(
	data: MultifiliacaoRg,
): ReducerActionRotaSP {
	return {
		type: Types.CADASTRO_RG_MULTIFILIACAO,
		payload: data,
	};
}

export function atualizarRgMultifiliacao(
	data: MultifiliacaoRg,
): ReducerActionRotaSP {
	return {
		type: Types.ATUALIZAR_RG_MULTIFILIACAO,
		payload: data,
	};
}
